/**
 * Helper function to extract error message from various error formats
 * @param {string|Error|Object} error - Error in various formats
 * @returns {string} - Extracted error message
 */
function extractErrorMessage(error) {
  if (typeof error === 'string') {
    return error;
  }
  if (error instanceof Error) {
    return error.message || 'An error occurred';
  }
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  if (error?.message) {
    return error.message;
  }
  return 'An unexpected error occurred';
}

export const statusSnackbar = {
  namespaced: true,
  state: {
    show: false,
    color: null,
    message: null,
    timeout: 6000, // Default timeout in milliseconds (6 seconds)
  },
  getters: {
    getTimeout: (state) => state.timeout,
  },
  actions: {
    show({ commit }, { message, color, timeout }) {
      commit('show', { message, color, timeout });
    },
    showSuccess({ commit }, message, timeout) {
      commit('show', { message, color: 'success', timeout });
    },
    showError({ commit }, messageOrError, timeout) {
      const message = extractErrorMessage(messageOrError);
      commit('show', { message, color: 'error', timeout });
    },
    showWarning({ commit }, message, timeout) {
      commit('show', { message, color: 'warning', timeout });
    },
    showInfo({ commit }, message, timeout) {
      commit('show', { message, color: 'info', timeout });
    },
    close({ commit }) {
      commit('close');
    },
  },
  mutations: {
    show(state, { message, color, timeout }) {
      state.message = message;
      state.color = color;
      state.timeout = timeout !== undefined ? timeout : 6000; // Default 6 seconds
      state.show = true;
    },
    close(state) {
      state.show = false;
      state.color = null;
      state.message = null;
    },
  },
};
